<template>
  <div class="container">
    <md-dialog :md-active.sync="modEditarMenu" :md-click-outside-to-close="false">
        <!-- <pre>{{ infoMenu[0] }}</pre> -->
        <md-dialog-title class="text-center">
            {{ labels.title }}
        </md-dialog-title>
        <md-dialog-content>
            <b-row class="">
                <b-col cols="2"></b-col>
                <b-col cols="4" class="text-left">
                    <h5>{{labels.name}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <md-field>
                        <md-input v-model="infoMenu[0].nombre"></md-input>
                    </md-field>
                </b-col>
            </b-row>
            <b-row class="">
                <b-col cols="2"></b-col>
                <b-col cols="4" class="text-left">
                    <h5>{{labels.ruta}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <md-field>
                        <md-input v-model="infoMenu[0].ruta"></md-input>
                    </md-field>
                </b-col>
            </b-row>
            <b-row class="">
                <b-col cols="2"></b-col>
                <b-col cols="4" class="text-left">
                    <h5>{{labels.icono}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <md-field>
                        <md-input v-model="infoMenu[0].icono"></md-input>
                    </md-field>
                </b-col>
            </b-row>
            <b-row class="">
                <b-col cols="2"></b-col>
                <b-col cols="4" class="text-left">
                    <h5>{{labels.orden}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <md-field>
                        <md-input v-model="infoMenu[0].orden"></md-input>
                    </md-field>
                </b-col>
            </b-row>
            <md-dialog-actions class="mt-2">
                <md-button class="md-primary" @click="guardarMenu">{{ labels.save }}</md-button>
                <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
            </md-dialog-actions>
        </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import Menu from '../../../services/Menu';

export default {
    name:"EditarMenu",
    props:['modEditarMenu','infoMenu'],
    data: () => ({
        nombre : "",
        ruta : "",
        icono : "",
        roles : [1,2],
        roll:[
            {
                id : 1,
                name : 'Admin',
            },
            {
                id : 2,
                name : 'Contad',
            },
            {
                id : 3,
                name : 'Revisor',
            }
        ],
        rolSelected: []
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar menú",
                    save : "Guardar",
                    close : "Cerrar",
                    name : "Nombre:",
                    ruta : "Ruta:",
                    icono : "Icono:",
                    roles : "Roles:",
                    orden : "Orden:",
                }
            }else{
                return {
                    title: "Edit menu",
                    save : "Save",
                    close : "Close",
                    name : "Name:",
                    ruta : "Route:",
                    icono : "Icon:",
                    roles : "Role:",
                    orden : "Order:",
                }
            }
        }
    },
    mounted(){
        // this.rolSelected = this.roles.filter(valor => this.roll.some(option => option.id === valor));
    },
    methods:{
        validaRolCheck(id){
            console.log(id)
        },
        cierraModal(){
            // console.log("CierraModal")
            this.$emit('closeModal',false)
        },
        guardarMenu(){
            // console.log("guardaMenu",this.roles)
            if(this.infoMenu[0].nombre == ""){
                this.$toast.error(`Diligenciar el campo Nombre`)
            
            }else if(this.infoMenu[0].ruta == ""){
                this.$toast.error(`Diligenciar el campo Ruta`)
            
            }else if(this.infoMenu[0].icono == ""){
                this.$toast.error(`Diligenciar el campo Icono`)

            }else if(this.infoMenu[0].orden == ""){
                this.$toast.error(`Diligenciar el campo Orden`)
            
            }else{
                let formu = {
                    'idMenu' : this.infoMenu[0].id,
                    'nombre' : this.infoMenu[0].nombre,
                    'ruta' : this.infoMenu[0].ruta,
                    'icono' : this.infoMenu[0].icono,
                    'orden' : this.infoMenu[0].orden,
                    // 'roles' : this.infoMenu[0].roles,
                    'idUser' : this.$store.state.userId
                }
                console.log(formu)

                Menu.updateMenuById(formu)
                .then((res) => {
                    // console.log(res)
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location.reload();
                    
                    }else if(res.status == 204){
                        this.$toast.error("El menú ingresado ya existe")
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        }
    }
}
</script>

<style>

</style>
